//
import {
  CONTROLESCOLAR_LISTA_ALUMNOS,
  CONTROLESCOLAR_LISTA_ALUMNOS_SUCCESS,
  CONTROLESCOLAR_LISTA_ALUMNOS_FAIL,
  CONTROLESCOLAR_UNSET_LISTA_ALUMNOS,
  CONTROLESCOLAR_LOGOUT,
  CONTROLESCOLAR_GET_PERSONA,
  CONTROLESCOLAR_GET_PERSONA_SUCCESS,
  CONTROLESCOLAR_GET_PERSONA_FAIL,
  CONTROLESCOLAR_PUT_PERSONA,
  CONTROLESCOLAR_PUT_PERSONA_SUCCESS,
  CONTROLESCOLAR_PUT_PERSONA_FAIL,
  CONTROLESCOLAR_UNSET_ERROR,
  CONTROLESCOLAR_SEND_PASSWORD,
  CONTROLESCOLAR_SEND_PASSWORD_SUCCESS,
  CONTROLESCOLAR_SEND_PASSWORD_FAIL,
  CONTROLESCOLAR_UNSET_NOTIFICACION,
  CONTROLESCOLAR_POST_PHOTO,
  CONTROLESCOLAR_POST_PHOTO_SUCCESS,
  CONTROLESCOLAR_POST_PHOTO_FAIL,
  CONTROLESCOLAR_SET_LISTAESTADOS,
  CONTROLESCOLAR_PUT_ODIRECCION,
  CONTROLESCOLAR_PUT_ODIRECCION_SUCCESS,
  CONTROLESCOLAR_PUT_ODIRECCION_FAIL,
  CONTROLESCOLAR_GET_ALUMNO,
  CONTROLESCOLAR_GET_ALUMNO_SUCCESS,
  CONTROLESCOLAR_GET_ALUMNO_FAIL,
  CONTROLESCOLAR_PUT_ALUMNO,
  CONTROLESCOLAR_PUT_ALUMNO_SUCCESS,
  CONTROLESCOLAR_PUT_ALUMNO_FAIL,
  CONTROLESCOLAR_GET_EMAIL,
  CONTROLESCOLAR_GET_EMAIL_SUCCESS,
  CONTROLESCOLAR_GET_EMAIL_FAIL,
  CONTROLESCOLAR_GET_CURP,
  CONTROLESCOLAR_GET_CURP_SUCCESS,
  CONTROLESCOLAR_GET_CURP_FAIL,
  CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION,
  CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION_SUCCESS,
  CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION_FAIL,
  CONTROLESCOLAR_UNSET_DESCUENTOS_INSCRIPCION,
  CONTROLESCOLAR_CREATE_ALUMNO,
  CONTROLESCOLAR_CREATE_ALUMNO_SUCCESS,
  CONTROLESCOLAR_CREATE_ALUMNO_FAIL,
  CONTROLESCOLAR_SET_RESPONSE_PARAMETROS,
  CONTROLESCOLAR_UNSET_MENSAJE_EXITO,
} from "./actionTypes"

// // Para poner mensajes exitosos
export const setControlEscolarResponseParametros = parameters => ({
  type: CONTROLESCOLAR_SET_RESPONSE_PARAMETROS,
  payload: { parameters },
})

// Quitar el mensaje Exito
export const unsetControlEscolarError = () => ({
  type: CONTROLESCOLAR_UNSET_ERROR,
})

// Quitar el mensaje Error
export const unsetControlEscolarMensajeExito = () => ({
  type: CONTROLESCOLAR_UNSET_MENSAJE_EXITO,
})

export const getControlEscolarDescuentosInscripcion = jsonparameters => ({
  type: CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION,
  payload: { jsonparameters },
})
export const getControlEscolarDescuentosInscripcionSuccess = data => ({
  type: CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION_SUCCESS,
  payload: { data },
})
export const getControlEscolarDescuentosInscripcionFail = error => ({
  type: CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION_FAIL,
  payload: error,
})
export const unsetControlEscolarDescuentosInscripcion = () => ({
  type: CONTROLESCOLAR_UNSET_DESCUENTOS_INSCRIPCION,
})

export const getControlEscolarGetCurp = jsonparameters => ({
  type: CONTROLESCOLAR_GET_CURP,
  payload: { jsonparameters },
})
export const getControlEscolarGetCurpSuccess = data => ({
  type: CONTROLESCOLAR_GET_CURP_SUCCESS,
  payload: { data },
})
export const getControlEscolarGetCurpFail = error => ({
  type: CONTROLESCOLAR_GET_CURP_FAIL,
  payload: error,
})

export const getControlEscolarGetEmail = jsonparameters => ({
  type: CONTROLESCOLAR_GET_EMAIL,
  payload: { jsonparameters },
})
export const getControlEscolarGetEmailSuccess = data => ({
  type: CONTROLESCOLAR_GET_EMAIL_SUCCESS,
  payload: { data },
})
export const getControlEscolarGetEmailFail = error => ({
  type: CONTROLESCOLAR_GET_EMAIL_FAIL,
  payload: error,
})

export const setControlEscolarListaEstados = data => ({
  type: CONTROLESCOLAR_SET_LISTAESTADOS,
  payload: { data },
})

export const postControlEscolarUploadPhoto = (jsonparameters, formData) => ({
  type: CONTROLESCOLAR_POST_PHOTO,
  payload: { jsonparameters, formData },
})
export const postControlEscolarUploadPhotoSuccess = data => ({
  type: CONTROLESCOLAR_POST_PHOTO_SUCCESS,
  payload: { data },
})
export const postControlEscolarUploadPhotoFail = error => ({
  type: CONTROLESCOLAR_POST_PHOTO_FAIL,
  payload: error,
})

export const ControlEscolarUnsetListaAlumnos = jsonparameters => ({
  type: CONTROLESCOLAR_UNSET_LISTA_ALUMNOS,
  payload: { jsonparameters },
})
export const ControlEscolarUnsetError = () => ({
  type: CONTROLESCOLAR_UNSET_ERROR,
})
export const ControlEscolarUnsetNotificacion = () => ({
  type: CONTROLESCOLAR_UNSET_NOTIFICACION,
})

export const postControlEscolarSendPassword = jsonparameters => ({
  type: CONTROLESCOLAR_SEND_PASSWORD,
  payload: { jsonparameters },
})
export const postControlEscolarSendPasswordSuccess = data => ({
  type: CONTROLESCOLAR_SEND_PASSWORD_SUCCESS,
  payload: { data },
})
export const postControlEscolarSendPasswordFail = error => ({
  type: CONTROLESCOLAR_SEND_PASSWORD_FAIL,
  payload: error,
})

export const putControlEscolarPutPersona = jsonparameters => ({
  type: CONTROLESCOLAR_PUT_PERSONA,
  payload: { jsonparameters },
})
export const putControlEscolarPutPersonaSuccess = data => ({
  type: CONTROLESCOLAR_PUT_PERSONA_SUCCESS,
  payload: { data },
})
export const putControlEscolarPutPersonaFail = error => ({
  type: CONTROLESCOLAR_PUT_PERSONA_FAIL,
  payload: error,
})

export const putControlEscolarPutoDireccion = jsonparameters => ({
  type: CONTROLESCOLAR_PUT_ODIRECCION,
  payload: { jsonparameters },
})
export const putControlEscolarPutoDireccionSuccess = data => ({
  type: CONTROLESCOLAR_PUT_ODIRECCION_SUCCESS,
  payload: { data },
})
export const putControlEscolarPutoDireccionFail = error => ({
  type: CONTROLESCOLAR_PUT_ODIRECCION_FAIL,
  payload: error,
})

export const getControlEscolarGetPersona = jsonparameters => ({
  type: CONTROLESCOLAR_GET_PERSONA,
  payload: { jsonparameters },
})
export const getControlEscolarGetPersonaSuccess = data => ({
  type: CONTROLESCOLAR_GET_PERSONA_SUCCESS,
  payload: { data },
})
export const getControlEscolarGetPersonaFail = error => ({
  type: CONTROLESCOLAR_GET_PERSONA_FAIL,
  payload: error,
})

export const getControlEscolarGetAlumno = jsonparameters => ({
  type: CONTROLESCOLAR_GET_ALUMNO,
  payload: { jsonparameters },
})
export const getControlEscolarGetAlumnoSuccess = data => ({
  type: CONTROLESCOLAR_GET_ALUMNO_SUCCESS,
  payload: { data },
})
export const getControlEscolarGetAlumnoFail = error => ({
  type: CONTROLESCOLAR_GET_ALUMNO_FAIL,
  payload: error,
})

export const putControlEscolarPutAlumno = jsonparameters => ({
  type: CONTROLESCOLAR_PUT_ALUMNO,
  payload: { jsonparameters },
})
export const putControlEscolarPutAlumnoSuccess = data => ({
  type: CONTROLESCOLAR_PUT_ALUMNO_SUCCESS,
  payload: { data },
})
export const putControlEscolarPutAlumnoFail = error => ({
  type: CONTROLESCOLAR_PUT_ALUMNO_FAIL,
  payload: error,
})

export const getControlEscolarListaAlumnos = jsonparameters => ({
  type: CONTROLESCOLAR_LISTA_ALUMNOS,
  payload: { jsonparameters },
})
export const getControlEscolarListaAlumnosSuccess = alumnos => ({
  type: CONTROLESCOLAR_LISTA_ALUMNOS_SUCCESS,
  payload: { alumnos },
})
export const getControlEscolarListaAlumnosFail = error => ({
  type: CONTROLESCOLAR_LISTA_ALUMNOS_FAIL,
  payload: error,
})

export const SetControlEscolarLogout = () => {
  console.log("export const SetControlEscolarLogout")
  return {
    type: CONTROLESCOLAR_LOGOUT,
  }
}

export const postControlEscolarCreateAlumno = jsonparameters => ({
  type: CONTROLESCOLAR_CREATE_ALUMNO,
  payload: { jsonparameters },
})
export const postControlEscolarCreateAlumnoSuccess = alumnos => ({
  type: CONTROLESCOLAR_CREATE_ALUMNO_SUCCESS,
  payload: { alumnos },
})
export const postControlEscolarCreateAlumnoFail = error => ({
  type: CONTROLESCOLAR_CREATE_ALUMNO_FAIL,
  payload: error,
})
